import "./Public.css";
import { useEffect, useState } from "react";
import logo from "../assets/Logo Fives Blanc.png";
// import PublicDatatableCollections from "./PublicDatatableCollections";
import AuthentificationChoice from "./AuthentificationChoice";
import EnterMail from "./EnterMail";
import SuccessDownload from "./SuccessDownload";
import Loc from "../../Loc/Loc";

export { Public }

function Public() {
    const [enterMail, setEnterMail] = useState(false);
    const [email, setEmail] = useState("");
    const [hash, setHash] = useState("");
    const [isSendingMail, setStateSendingMail] = useState(false);
    const [isSendingSMS, setStateSendingSMS] = useState(false);
    const [waitingForCode, setWaitingForCode] = useState(false);
    const [accessAuthorized, setAccess] = useState(false);
    const [type, setType] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        let url: string = document.location.href;
        let hash: string = "";
        let email: string = "";
        if (url.split("hash=").length > 1) { // si l'url contient un hash
            hash = url.split("hash=")[1];
            setHash(hash);
            if (hash && hash.split("&email=").length > 1) {
                hash = hash.split("&email=")[0];
                setHash(hash);
            }
        }
        if (url.split("email=").length > 1) {
            email = url.split("email=")[1];
            setEmail(email);
        }
        console.log("hash : " + hash);
        console.log("email : " + email);
        isSendingMail ? setType("mail") : isSendingSMS ? setType("sms") : setType(type);
    }, [setType, isSendingMail, isSendingSMS, type])

    return (
        <div className="publicPage">
            <div className="publicCard">
                {accessAuthorized ? <SuccessDownload setAccess={setAccess} setWaitingForCode={setWaitingForCode} setEnterMail={setEnterMail}></SuccessDownload>/*<PublicDatatableCollections></PublicDatatableCollections>*/ :
                    <div style={{ textAlign: 'center', background: '#af007c' }}>
                        <img src={logo} alt="logo Fives" />
                        {enterMail ? <EnterMail setAccess={setAccess} isSendingMail={isSendingMail} isSendingSMS={isSendingSMS} waitingForCode={waitingForCode} type={type} email={email} setEnterMail={setEnterMail} setStateSendingMail={setStateSendingMail} setWaitingForCode={setWaitingForCode} setEmail={setEmail} setError={setError} error={error} hash={hash} ></EnterMail> :
                            <div>
                                <h1 style={{ color: 'white' }}>{Loc.trad().PublicQuestion}</h1>
                                <AuthentificationChoice setEnterMail={setEnterMail} setStateSendingSMS={setStateSendingSMS} setWaitingForCode={setWaitingForCode}></AuthentificationChoice>
                            </div>}
                    </div>}
            </div>
        </div>
    )
}